import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SpinnerService } from 'shared-components';
import { DataService } from '../../../../services/data.service';

@Component({
    selector: 'app-estadisticas-etiquetado-cpd',
    templateUrl: './estadisticas-etiquetado-cpd.component.html'
})
export class EstadisticasEtiquetadoCPDComponent implements OnInit {

    public tipoEstadisticas = 1;
    public gridModal = false;
    public tituloGrid;
    public dataGrid;

    @Input() graficasEtiquetadoFiltroCompleto;
    @Input() filtrado;

    @Output() showWarning = new EventEmitter<any>(true);

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _dataService: DataService) {}

    ngOnInit() {
        this.showKilosPais();
    }

    public async showKilosPais() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 1;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab1: true
        });
    }

    public async showKilosDenominacion() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 2;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab2: true
        });
    }

    public async showKilosCampanyasEtiquetadores() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 4;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab4: true
        });
    }

    public async showKilosEtiquetadores() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 5;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab5: true
        });
    }

    public delay(ms: number) {
        return new Promise( resolve => setTimeout(resolve, ms) );
    }

    public exportarDataPDFExcel(graficasTab: any, service: string, paisId: number, denominacionId: number, campanyaId: any, tipo: string){
      if (this.graficasEtiquetadoFiltroCompleto && graficasTab && graficasTab.length > 0) {
        let filters = {
          lsPaisId: paisId,
          lsDenominacionId: denominacionId,
          lsCampanyasDeAnyo: campanyaId == 0 || !campanyaId ? [] : typeof campanyaId == 'number' ? [campanyaId] : campanyaId,
          tipoArchivo: ""
        };
        if (tipo === 'excel') {
          filters.tipoArchivo = 'Excel';
        } else if (tipo === 'pdf') {
          filters.tipoArchivo = 'Pdf';
        } else {
          filters.tipoArchivo = 'csv';
        }

        this._spinnerService.showSpinner();
        this._dataService[service](filters).toPromise().finally(() => {
          this._spinnerService.hideSpinner();
        }).then((resp) => {
          const downloadLink = document.createElement('a');
          downloadLink.href = (tipo === 'pdf' ? 'data:application/pdf;base64,' : 'data:application/vnd.ms-excel;base64,') + resp.base64Archivo;
          downloadLink.download = resp.nombreArchivo;
          downloadLink.click();
        });
      } else {
       //   this.showError = true;
       //   this.mensajes.push({ class: 'error', message: 'global.error.exportNoData' });
      }
    }

    public showGrid(paisId: any, pais: string, denominacionId: any, denominacion: string, anyo: any, service: string, title: string){
        this.tituloGrid = title;
        this.dataGrid = { paisId: paisId, pais: pais, denominacionId: denominacionId, denominacion: denominacion, anyo: anyo, service: service };
        this.gridModal = true;
    }

    public refresh(){
        this.gridModal = false;
    }
}

